import { render, staticRenderFns } from "./RecipeDetails.vue?vue&type=template&id=c795ec3c&"
import script from "./RecipeDetails.vue?vue&type=script&lang=js&"
export * from "./RecipeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports